import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { environment } from '../../environments/environment';

/**
 * Wraps Auth0's AuthGuard. The test stage has no Auth0 provider, so every route is open there;
 * every other stage requires a signed-in user.
 */
export const proxyAuthGuard: CanActivateFn = (route, state) => {
    if (environment.stage === 'test') {
        return true;
    }
    return inject(AuthGuard).canActivate(route, state);
};
